import styled from 'styled-components';

export const StyledPaginatedArticleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-4);
  }

  & > div button {
    padding: var(--space-2) var(--space-4);
    background-color: var(--c-surface-2);
    color: var(--c-text);
    border: var(--border);
    border-radius: var(--radius-md);
    font-size: var(--fs-sm);
    font-weight: var(--fw-bold);
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease,
      opacity 0.2s ease;
  }

  & > div button:hover:not(:disabled) {
    border-color: var(--c-accent);
    background-color: var(--c-elevated);
  }

  & > div button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  & > div span {
    min-width: 4ch;
    text-align: center;
    font-size: var(--fs-sm);
    color: var(--c-text-muted);
    font-variant-numeric: tabular-nums;
  }
`;
